export default __webpack_public_path__ + "static/small-image-norsk-1-c06d5ea7d67bb7b119f44cb42b07c003.png";